import React from 'react'

const EducationIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="240" height="216" viewBox="0 0 240 216" {...props}>
    <path
      fill="currentColor"
      fillRule="nonzero"
      stroke="none"
      strokeWidth="1"
      d="M264 119.04V246a6 6 0 01-6 6h-9a6 6 0 01-6-6V139.2l-85.68 61.68a17.88 17.88 0 01-10.08 3.12h-6.48a17.88 17.88 0 01-10.08-3.12l-104.04-75a5.88 5.88 0 01-2.64-4.92v-1.92a5.88 5.88 0 012.64-4.92l104.04-75A17.88 17.88 0 01140.76 36h6.48a17.88 17.88 0 0110.08 3.12l104.04 75a5.88 5.88 0 012.64 4.92zM147.24 225h-6.48a39.96 39.96 0 01-22.44-7.08L72 184.44V204c0 26.52 32.28 48 72 48s72-21.48 72-48v-19.56l-46.8 33.72a39 39 0 01-21.96 6.84z"
      transform="translate(-130 -142) translate(106 106)"
    />
  </svg>
)

export default EducationIcon
